module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-dark-8096015b42e2f8c965ab705360bec1c0.png";